import { Component, Shark, Utils } from "shark-mvc";
import $ from "jquery";
import moment from "moment";

import templateContent from "./close-ncr-modal.html";

import followUpManager from "../../_shark_jaws/managers/followUpManager";
import { informationModalComponent } from "../../components/informationModal/informationModalComponent";
// import { teamUpManager } from "../../_shark_jaws/managers/teamUpManager";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";
// import ccaDetailsManager from "../../controllers/ccaDetailsManager";
import { notComplianceReportManager } from "../../_shark_jaws/managers/notComplianceReportManager";
import NotComplianceReport from "../../_shark_models/NotComplianceReport";

class CloseNCRModalComponent extends Component {
	constructor () {
		super("closeNCRModalComponent");

		this.addTemplate("", templateContent);
	}

	afterRender () {
		if (this.get("open")) {
			this.open();
		}
	}

	close () {
		Shark.set({
			currNotComplianceReport: null
		});

		this.set({
			open: false,
		});
		$("#setNCRAsClosedModal").modal("hide");
	}

	
	init () {
		this.addComponents([informationModalComponent, waitBoxComponent]);
	}

	open () {
		Shark.render();
		$("#setNCRAsClosedModal").modal("show");
		this.set({
			open: true,
		});
	}

	setNCRAsClosedModalConfirmBtn_clickHandler () {
		waitBoxComponent.open();
		const currNotComplianceReport = Shark.get("currNotComplianceReport");
		
		if (currNotComplianceReport) {
			const validationErrors = currNotComplianceReport.validate();

			if (validationErrors.length > 0) {
				waitBoxComponent.close();
				alert("Attenzione, si sono verificati i seguenti errori:\n\n" + validationErrors.join("\n"));
			}
			else {
				const successfullyManaged = currNotComplianceReport.verificationData.successfullyManaged;

				if (successfullyManaged === null) {
					waitBoxComponent.close();
					alert("Devi indicare se la Non Conformità è stata risolta in modo efficace o no!");
				}
				else {
					currNotComplianceReport.set({
						conclusionDate: moment(),
						status: NotComplianceReport.STATUS_CLOSED,
					});
	
					notComplianceReportManager.save(currNotComplianceReport)
					.then(() => {
						let closingNote = currNotComplianceReport.verificationData.consequencesIPM.trim();
						closingNote = closingNote === "" ? "" : ` Sono state aggiunte le seguenti note: <span role="user-note">${closingNote}</span>`;

						const newFollowUp = Shark.getInstance("ClientFollowUp", {
							body: `Il Rapporto di non Conformità <strong>${currNotComplianceReport.__numberLabel}</strong> è stato chiuso, la Non Conformità è stata risolta in modo <strong>${!successfullyManaged ? "non " : ""}efficace</strong>.${closingNote}`,
							clientGuid: currNotComplianceReport.clientGuid,
							referenceGuid: currNotComplianceReport.guid,
							referenceType: "notComplianceReport",
							status: 3,
							type: "system"
						});
	
						followUpManager.save(newFollowUp)
						.then(() => {
							waitBoxComponent.close();
							this.close();
							if (typeof Shark.activePage.refreshList === "function") {
								Shark.activePage.refreshList();
							}
							else {
								Shark.render();
							}
						});
					});
				}
			}
		}
	}

	setNCRAsClosedBtn_clickHandler (event, data) {
		const currNotComplianceReport = Utils.safp(Shark.get("notComplianceReportList"), "guid", data.guid);

		Shark.set({
			currNotComplianceReport
		});

		this.open();
	}

	setNCRAsClosedModalCancelBtn_clickHandler () {
		const currNotComplianceReport = Shark.get("currNotComplianceReport");
		currNotComplianceReport.restore();

		this.close();
	}
}

const closeNCRModalComponent = new CloseNCRModalComponent();

Shark.registerComponent(closeNCRModalComponent);

export default closeNCRModalComponent;
